import confetti from 'canvas-confetti';

const DROPS_PER_XRP = 1_000_000n;

function formatXrp(drops) {
  const whole = drops / DROPS_PER_XRP;
  const fraction = (drops % DROPS_PER_XRP).toString().padStart(6, '0');
  return `${whole.toString()}.${fraction} XRP`;
}

export class WinDialog {
  constructor(dialog) {
    this.dialog = dialog;
    dialog.querySelector('#win-close').addEventListener('click', () => {
      dialog.close();
    });
    dialog.querySelector('#win-copy').addEventListener('click', async () => {
      const privateKeyHex = dialog.querySelector('#win-private-key').textContent;
      try {
        await navigator.clipboard.writeText(privateKeyHex);
        const btn = dialog.querySelector('#win-copy');
        const orig = btn.textContent;
        btn.textContent = 'Copied!';
        setTimeout(() => (btn.textContent = orig), 1500);
      } catch {
        // Clipboard access may be denied; user can still copy manually.
      }
    });
  }

  show(result) {
    this.dialog.querySelector('#win-address').textContent = result.classicAddress;
    this.dialog.querySelector('#win-balance').textContent = formatXrp(
      result.balanceDrops
    );
    this.dialog.querySelector('#win-private-key').textContent =
      result.privateKeyHex;
    this.dialog.querySelector('#win-public-key').textContent = result.publicKeyHex;

    if (typeof this.dialog.showModal === 'function') {
      this.dialog.showModal();
    } else {
      this.dialog.setAttribute('open', '');
    }

    fireConfetti();
  }
}

function fireConfetti() {
  const burst = (opts) =>
    confetti({
      particleCount: 100,
      spread: 75,
      origin: { y: 0.6 },
      ...opts,
    });
  burst({});
  setTimeout(() => burst({ angle: 60, origin: { x: 0, y: 0.7 } }), 200);
  setTimeout(() => burst({ angle: 120, origin: { x: 1, y: 0.7 } }), 400);
}
